module.exports = __webpack_public_path__ + "static/media/404.46dfd307.gif";